export enum PopupType {
  CALENDAR = 'calendar',
  SELECT = 'select',
}
